import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { space, width } from 'styled-system';

import { Flex } from 'common/components/Flex';
import { Link } from 'common/components/Link';
import { BodyRegularBR1, HeadlineH4 } from 'common/components/Typography';
import { boxSizing } from 'common/theme/system-utilities';
import type { BrandsSectionProps } from './types';
import { getBrandsSectionId } from './utils';

const Section = styled.section<any>`
  ${space};

  :last-of-type {
    margin-bottom: 0;
  }
`;

const headingStyles: ComponentProps<typeof HeadlineH4> = {
  as: 'h3',
  mt: 'sp_0',
  mb: ['sp_4', 'sp_8'],
};

const BrandsList = styled(Flex)<any>`
  list-style: none;
`;

const brandsListStyles: ComponentProps<typeof BrandsList> = {
  as: 'ul',
  p: 'sp_0',
  flexWrap: 'wrap',
  m: 'sp_0',
};

const Brand = styled.li<any>`
  ${space};
  ${width};
  ${boxSizing};
`;

const brandStyles: ComponentProps<typeof Brand> = {
  mb: 'sp_8',
  pr: 'sp_8',
  width: [1, 1 / 2, 1 / 3, 1 / 4],
  boxSizing: 'border-box',
};

const BrandsSection = ({ brandsSection: { key, brands } }: BrandsSectionProps) => (
  <Section mb={['sp_8', null, 'sp_12', 'sp_16']} id={getBrandsSectionId(key)}>
    <HeadlineH4 {...headingStyles}>{key}</HeadlineH4>
    <BrandsList {...brandsListStyles}>
      {brands.map(({ name, url }) => (
        <Brand {...brandStyles} key={name}>
          <Link href={url}>
            <BodyRegularBR1 as="span" color="inherit">
              {name}
            </BodyRegularBR1>
          </Link>
        </Brand>
      ))}
    </BrandsList>
  </Section>
);

export default BrandsSection;
